// extracted by mini-css-extract-plugin
module.exports = {"stars":"styles_stars__uYg72","star":"styles_star__nJhEO","half":"styles_half__OwRW0","empty":"styles_empty__ocntG"};